<template>
  <div id="app">
    <!-- <div class="login_logo hidden-sm-and-down"><img src="../../assets/images/login_logo.png"></div> -->
    <div class="login_box center-block regist">
      <!-- <el-alert
		    title="请仔细阅读《超导材料研究—三才示例站点》的注册用户隐私政策。"
		    type="success"
		    show-icon
		  >
      </el-alert>-->
      <div class="xbjj_con">
        <div class="login_box_title">Privacy policy</div>
        <!-- <div class="pravacy_scroll ten">
          <div>
            <div class="news_datail_title">1. 关于数据保护的概述</div>
            <div>我们将简要概述当您访问我们的官网时，您的个人信息所发生的情况。个人信息是我们用来识别客户身份的隐私数据。有关隐私数据保护的详细信息，请参阅下面的隐私政策。</div>
          </div>
          <div>
            <div class="news_datail_title">官网上的数据收集</div>
            <div class="five">是谁负责在此官网上进行收据收集？</div>
            <div class="five">本官网收集的数据由网站运营商处理，运营商的联系方式可以在该网站的法律声明</div>
          </div>
          <div>
            <div class="news_datail_title">我们如何收集您的数据</div>
            <div class="five">部分数据是在您主动提供给我们时收集的，比如您在填写联系表时输入的数据。</div>
            <div
              class="five"
            >其他数据是在您访问我们的网站时由IT系统自动收集的，这些数据主要是技术参数，比如您在访问网站时所使用的浏览器和操作系统，这些数据会在您进入我们的网站时自动收集。</div>
          </div>
          <div>
            <div class="news_datail_title">我们如何使用您的数据</div>
            <div class="five">一部分的数据被用来确保网站的正常运作，其他数据可用于分析访问者的使用情况。</div>
          </div>
          <div>
            <div class="news_datail_title">关于数据您所拥有的权利</div>
            <div
              class="five"
            >您始终有权要求无偿获取关于您的存储数据，包括其来源，接收者以及收集的目的；您也有权利对数据要求更正，阻止或者删除。如果您有关于隐私和数据保护的任何相关问题，您可以随时使用法律声明中所提供的联系方式来与我们进行沟通。同时，您也可以向监管部门进行投诉。</div>
          </div>
          <div>
            <div class="news_datail_title">分析和第三方工具</div>
            <div
              class="five"
            >在您访问我们的网站时，您的网上浏览行为可能会被统计，这主要通过分析和使用cookie。这种类型的分析通常是匿名进行的，即我们无法从这些数据中识别出您的身份。您同样可以通过不使用特定的网上工具来阻止该操作，详细信息可以在以下隐私政策中找到。</div>
            <div class="five">您可以拒绝此类数据分析，我们将在以下信息中介绍详细的操作。</div>
          </div>
          <div>
            <div class="news_datail_title ten">2. 重要信息</div>
            <div class="five">数据保护</div>
            <div class="five">本官网的运营商致力于保护您的隐私数据，我们会根据法律保护条例和本站的隐私政策来保密处理您的个人数据。</div>
            <div
              class="five"
            >在您浏览本网站时，我们会收集您的个人资料。个人信息的主要功能是识别用户，本隐私政策将会说明我们收集的资料类型和用途，它同样解释了资料收集如何发生以及收集目的。</div>
            <div class="five">请注意，通过互联网传输的数据（比如电子邮箱）可能会受到安全漏洞的影响，因此，私人数据的完全保护（不受第三方的访问）是不可能的。</div>
          </div>
          <div>
            <div class="news_datail_title">数据处理的终止</div>
            <div
              class="five"
            >许多的数据处理只有在您的明确同意的前提下才可以进行，您随时可以撤销该决定。您可以通过非正式电子邮件来提出此要求，需要注意的是，在我们收到您的要求之前，我们依然可以合法处理您的数据。</div>
          </div>
          <div>
            <div class="news_datail_title">投诉</div>
            <div class="five">如果发生违反数据保护法，客户可向网络监管机构提出投诉。</div>
          </div>
          <div>
            <div class="news_datail_title">数据移植</div>
            <div class="five">您有权将隐私数据以标准可读的格式自动发送给您或者第三方。 在技术允许的情况下，您可以将数据直接传输给其他责任方。</div>
          </div>

          <div>
            <div class="news_datail_title">信息的阻止和删除</div>
            <div
              class="five"
            >根据法律规定，您有权在任何时候要求免费获取已处理过的个人存储数据以及其来源，收件人和处理目的。 您也有更正，阻止或删除此数据的权利。 如果您关于个人数据还有其他疑问，您可以随时通过法律声明中提供的信息来与我们取得联系。</div>
          </div>

          <div>
            <div class="news_datail_title">反推销</div>
            <div
              class="five"
            >应网站法律声明要求，我们在此明确禁止将客户的联系数据发送给未授权的促销商和广告商。如果收到来源可疑的广告材料（例如电子垃圾邮件），网站运营商将保留采取特定法律行动的权利。</div>
          </div>
          <div>
            <div class="news_datail_title ten">3. 数据保护员</div>
            <div>法定资料保护员</div>
            <div class="five">我们已为自己的公司指定了一名专职数据保护的职员</div>
          </div>

          <div>
            <div class="news_datail_title ten">4.有关本网站的数据收集</div>
            <div>Cookies</div>
            <div
              class="five"
            >我们的一些网页会使用cookies。Cookies不会损害您的计算机，也不会包含任何病毒。 Cookies有助于使我们的网站能更友好地服务客户，更高效和更安全。 Cookie是存储于计算机中的小型文本文件，并由浏览器保存。</div>
            <div
              class="five"
            >我们使用的大多数Cookie都是临时的，在您的网站访问结束后它们会被自动删除。其他的Cookie则被保留在设备内存中，直到您主动删除。 这些cookie可以帮助我们在您下次访问时识别您的浏览器。</div>
            <div
              class="five"
            >您可以通过配置浏览器来使用Cookie，以便您可以根据具体情况来决定是接受还是拒绝。除此以外，您也可以将浏览器设定为在特定条件下自动接受Cookie，或始终拒绝它们，或在关闭浏览器时自动删除。另外，禁用cookies可能会限制本网站的功能。</div>
            <div
              class="five"
            >根据Art.6, 第1段，DSGVO的f条款，Cookie可允许电子通讯或提供某些您希望使用的功能（例如购物车）。网站运营商对cookie的存储具有合法的权益，以确保提供无任何技术错误的优质服务。如果系统内还储存了其他Cookie（例如用于分析您的网上浏览行为的cookie），则会根据隐私政策来作单独处理。</div>
          </div>
          <div>
            <div class="news_datail_title">服务器日志</div>
            <div>网站提供商会自动收集并储存由您的浏览器发送给我们的服务器日志，这些信息包括</div>
            <div class="five">• 浏览器的类型和版本</div>
            <div class="five">• 操作系统</div>
            <div class="five">• 推荐网址</div>
            <div class="five">• 计算机的主机名</div>
            <div class="five">• 服务器的请求时间</div>
            <div class="five">• IP地址</div>
            <div class="five">这些信息不会与其他来源的信息进行合并。</div>
          </div>

          <div>
            <div class="news_datail_title ten">5.期刊</div>
            <div>期刊数据</div>
            <div
              class="five"
            >如果您想收到我们的期刊，只需要在同意相关条款后向我们提供一个有效且经过验证的电子邮件地址。在用户自愿的基础上，我们只收集必要的数据，并合理地处理它们，不会泄露给第三方。</div>
            <div
              class="five"
            >因此，我们会依据Art. 6 (1) (a) DSGVO，在得到您的同意后，处理您在表单中输入的信息。您随时可以撤销该决定并通过选择"取消订阅"来停止接收期刊。需要注意的是，在我们收到您的要求之前，我们依然可以合法处理您的数据。</div>
            <div class="five">在您取消订阅并要求将数据删除之前，用户注册时提供的数据将被用于期刊的宣传工作。其他数据（例如会员的电子邮件地址）将不受此影响。</div>
          </div>
        </div> -->
       
        <div class="pravacy_scroll ten" v-html="Body">
        </div>
        <div class="ten highblue reg_checkbox">
          <el-checkbox
            v-model="checked"
          >I have read privacy policy of 《{{$store.state.Name}}》and like to accept.</el-checkbox>
        </div>
        <div class="text-center twenfive">
          <el-button type="primary" :disabled="disabled" @click="goReg">Next</el-button>
          <el-button @click="$router.push('/')">Cancel</el-button>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="login_other_button" style=" margin-top: 25px;"></div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import Login_WeiXin from "../../components/Login/Login_WeiXin";

export default {
  name: "Pravacy",
  data() {
    return {
      showWx: false,
      checked: false,
      disabled: true,
      Body:"",
    };
  },
  components: {
    Login_WeiXin,
  },
  deactivated() {
    this.showWx = false;
    this.checked = false;
    this.disabled = true;
  },
  watch: {
    checked() {
      this.disabled = !this.checked;
    },
  },
  mounted() {
    this.$store.dispatch("_getHeader", [parseInt(91)]).then((res) => {
      if (res.data.IsSuccess) {
         if(res.data.Data.length>0){
           this.Body = res.data.Data[0].Body || "";
         }
        
      }
    });
  },
  methods: {
    wxshow() {
      this.showWx = true;
    },
    goReg() {
      this.$parent.num = true;
    },
  },
};
</script>

<style scoped>
.login_box {
  margin-top: 0 !important;
}
.login_box {
  padding: 10px !important;
}
@media (max-width: 768px) {
  .pravacy_scroll {
    max-width: 550px;
  }
}
@media (max-width: 420px) {
  .pravacy_scroll {
    max-width: 100%;
  }
}
@media (min-width: 768px) {
  .login_box {
    max-width: 100% !important;
  }
}
</style>
